(function () {
  const PROXY_URL = "/apps/metalbox/wishlist";

  function getCustomerId() {
    return window.__wishlistCustomerId || null;
  }

  async function fetchWishlist() {
    const customerId = getCustomerId();
    if (!customerId) return [];
    try {
      const res = await fetch(`${PROXY_URL}?customer_id=${encodeURIComponent(customerId)}`, {
        credentials: "same-origin",
      });
      if (!res.ok) return [];
      const data = await res.json();
      return data.items || [];
    } catch (e) {
      console.error("Wishlist: échec de la récupération", e);
      return [];
    }
  }

  function markHearts(items) {
    const ids = new Set(items.map((i) => String(i.productId)));
    document.querySelectorAll(".wishlist-heart").forEach((btn) => {
      const productId = btn.dataset.productId;
      if (ids.has(productId)) {
        btn.setAttribute("aria-pressed", "true");
      }
    });
  }

  // ---------------------------------------------------------------------
  // Pop-up "connexion / création de compte" affiché quand un visiteur non
  // connecté clique sur un cœur wishlist.
  // ---------------------------------------------------------------------
  let activeOverlay = null;

  function closeLoginPrompt() {
    if (activeOverlay) {
      activeOverlay.remove();
      activeOverlay = null;
      document.removeEventListener("keydown", handleEscape);
    }
  }

  function handleEscape(e) {
    if (e.key === "Escape") closeLoginPrompt();
  }

  function showLoginPrompt() {
    if (activeOverlay) return; // déjà affiché

    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);

    const overlay = document.createElement("div");
    overlay.className = "wishlist-login-popup-overlay";
    overlay.innerHTML = `
      <div class="wishlist-login-popup" role="dialog" aria-modal="true" aria-labelledby="wishlist-login-popup-title">
        <button type="button" class="wishlist-login-popup__close" aria-label="Fermer">&times;</button>
        <p id="wishlist-login-popup-title" class="wishlist-login-popup__title">Envie de créer votre wishlist ?</p>
        <p class="wishlist-login-popup__text">Connectez-vous ou créez un compte pour enregistrer vos coups de cœur.</p>
        <div class="wishlist-login-popup__actions">
          <a class="wishlist-login-popup__button wishlist-login-popup__button--primary" href="/account/login?return_url=${returnUrl}">Se connecter</a>
          <a class="wishlist-login-popup__button wishlist-login-popup__button--secondary" href="/account/login?return_url=${returnUrl}">Créer un compte</a>
        </div>
      </div>
    `;

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) closeLoginPrompt();
    });
    overlay.querySelector(".wishlist-login-popup__close").addEventListener("click", closeLoginPrompt);

    document.body.appendChild(overlay);
    activeOverlay = overlay;
    document.addEventListener("keydown", handleEscape);
  }

  async function toggleWishlist(btn) {
    const productId = btn.dataset.productId;
    const customerId = getCustomerId();
    const isActive = btn.getAttribute("aria-pressed") === "true";
    const method = isActive ? "DELETE" : "POST";

    if (!customerId) {
      showLoginPrompt();
      return;
    }

    btn.setAttribute("aria-pressed", String(!isActive));
    btn.disabled = true;

    try {
      const res = await fetch(PROXY_URL, {
        method,
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ productId, customerId }),
      });

      if (!res.ok) {
        throw new Error("Échec de la requête wishlist");
      }
    } catch (e) {
      btn.setAttribute("aria-pressed", String(isActive));
      console.error("Wishlist: échec de la mise à jour", e);
    } finally {
      btn.disabled = false;
    }
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".wishlist-heart");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(btn);
  });

  document.addEventListener("DOMContentLoaded", async () => {
    const items = await fetchWishlist();
    markHearts(items);
  });
})();
